import { ethers } from "ethers";

export const ENTRY_FEE = ethers.utils.parseUnits("0.1", "ether");
export const DEFAULT_BLENDING_PRICE = ethers.utils.parseUnits("0.1", "ether");
export const SELF_BLEND_PRICE = ethers.utils.parseUnits("0.5", "ether");
